export default "__VITE_ASSET__D$iZaFmB__"